export default __webpack_public_path__ + "static/media/ShockBaton.256.06d564b8.png";